import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { MenuList, MenuItem, Drawer, ListItemIcon } from '@material-ui/core';
import {
  People,
  VpnKey,
  Domain,
  ViewComfy,
  Ballot,
  Style,
  House,
  Input,
} from '@material-ui/icons';
import SyncIcon from '@material-ui/icons/Sync';
import { useSyles } from './styles';
import { SystemActions } from '../../../domain/constants/SystemActions';
import { RolePermissions } from '../../../domain/constants/RolePremissions';

const Menu = ({ variant, open, onClose }) => {
  const { type } = useSelector((state) => state.auth);
  const classes = useSyles();

  const listMenu = [
    {
      label: 'Dashboard',
      link: '/',
      Icon: Ballot,
      permission: 0,
    },
    {
      label: 'Almacenes',
      link: '/warehouses',
      Icon: Domain,
      permission: SystemActions.read_warehouses,
    },
    {
      label: 'Gavetas',
      link: '/drawers',
      Icon: ViewComfy,
      permission: SystemActions.read_drawers,
    },
    {
      label: 'Propiedades',
      link: '/properties',
      Icon: House,
      permission: SystemActions.read_properties,
    },

    {
      label: 'Llaves',
      link: '/housekeys',
      Icon: VpnKey,
      permission: SystemActions.read_keys,
    },
    {
      label: 'Préstamos',
      link: '/loans',
      Icon: Style,
      permission: SystemActions.read_loans_by_session,
    },
    {
      label: 'Devolucion',
      link: '/repayments',
      Icon: Input,
      permission: SystemActions.edit_loans,
    },
    {
      label: 'Préstamos P2P',
      link: '/p2p/loans',
      Icon: SyncIcon,
      permission: SystemActions.read_loans_p2p,
    },
    {
      label: 'Usuarios',
      link: '/users',
      Icon: People,
      permission: SystemActions.read_users,
    },
  ];

  const currentLocation = window.location.pathname;
  return (
    <Drawer
      className={classes.menu}
      open={open}
      onClose={onClose ? onClose : null}
      variant={variant}
    >
      <MenuList className={classes.menu}>
        <div className={classes.toolbar} key={'toolbar-key'}></div>
        {listMenu.map(({ Icon, link, label, permission }, index) => {
          const isSelected = currentLocation.startsWith(link) && link !== '/';
          return (
            <>
              {(RolePermissions.allowed(type, permission) ||
                permission === 0) && (
                <Link key={`menu-items-${index}`} to={link} color='primary'>
                  <MenuItem
                    className={`${classes.menuItem} !rounded-r-full ${
                      isSelected
                        ? '!bg-[#7C01FF] !text-white !font-semibold'
                        : ''
                    }`}
                    selected={isSelected}
                  >
                    {!!Icon && (
                      <ListItemIcon>
                        <Icon
                          className={`${classes.iconItem} ${
                            isSelected ? '!text-white' : ''
                          }`}
                        />
                      </ListItemIcon>
                    )}
                    {label}
                  </MenuItem>
                </Link>
              )}
            </>
          );
        })}
      </MenuList>
    </Drawer>
  );
};
export default Menu;
